import { Icon } from '@/new/components/icon';
import { cn } from '@/new/lib/utils';

interface Step {
  id: string;
  label: string;
  icon: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStepIndex: number;
}

export function StepIndicator({ steps, currentStepIndex }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-start">
      <div className="flex items-center">
        {steps.map((step, index) => {
          const isActive = currentStepIndex === index;
          const isCompleted = currentStepIndex > index;

          return (
            <div key={step.id} className="flex items-center">
              <div className="flex items-center">
                <div
                  className={cn(
                    'relative flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all duration-300',
                    isActive
                      ? 'scale-105 border-teal-600 bg-teal-600'
                      : isCompleted
                        ? 'border-teal-500 bg-teal-500'
                        : 'border-gray-300 bg-white',
                  )}
                >
                  {isCompleted ? (
                    <Icon className="lucide--check text-sm font-semibold text-white" />
                  ) : (
                    <Icon className={cn('text-sm', step.icon, isActive ? 'text-white' : 'text-gray-400')} />
                  )}
                </div>

                <div className="ml-2.5">
                  <span
                    className={cn(
                      'text-xs font-medium transition-colors duration-300',
                      isActive ? 'text-teal-700' : isCompleted ? 'text-teal-600' : 'text-gray-500',
                    )}
                  >
                    {step.label}
                  </span>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="mx-4 flex h-0.5 w-12 items-center">
                  <div
                    className={cn(
                      'h-full w-full rounded-full transition-all duration-500',
                      isCompleted ? 'bg-teal-500' : 'bg-gray-200',
                    )}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
